<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15sX59Q/tc-custom/9780544188433.jpg?1736916380963" alt="This image is the cover for the book Paleo Answer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Paleo Answer
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The book that “takes Paleo to the next level” for optimal weight loss and total health—from the world’s leading expert on paleolithic eating styles (Robb Wolf, <i>New York Times</i> bestselling author of <i>The Paleo Solution</i>).</b></p><p>Dr. Loren Cordain’s bestselling <i>The Paleo Diet</i> and <i>The Paleo Diet Cookbook</i> have helped hundreds of thousands of people eat for better health and weight loss by following the diet humans were genetically designed to eat: meats, fish, fresh fruits, vegetables, nuts and other foods that mimic the diet of our Paleolithic ancestors.</p><p>In <i>The Paleo Answer</i>, he shows you how to supercharge the Paleo Diet for optimal lifelong health and weight loss. Featuring a new prescriptive 7-day plan and surprising revelations from the author’s original research, this is the most powerful Paleo guide yet.</p>Based on the author’s groundbreaking research on Paleolithic diet and lifestyleIncludes a new 7-day plan with recommended meals, exercise routines, lifestyle tips, and supplement recommendationsReveals fascinating findings from the author’s research over the last decade, such as why vegan and vegetarian diets are not healthy and why dairy, soy products, potatoes, and grains can be harmful to our healthIncludes health and weight-loss advice for all Paleo dieters—women, men, and people of all ages—and is invaluable for CrossFitters and other athletes<p>Whether you’ve been following a Paleo-friendly diet and want to take it to the next level or are just discovering the benefits of going Paleo, this book will help you follow the Paleo path to the fullest—for lifelong health, increased energy, better sleep, lower stress and weight loss.</p> 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Loren Cordain
      </h2>
      
      <p class="authorDescription body article">LOREN CORDAIN, Ph.D., is one of the top global researchers in the area of evolutionary medicine. Generally acknowledged as the world's leading expert on the Paleolithic diet, he is a professor in the Health and Exercise Science Department at Colorado State University. Dr. Cordain and his research have been featured on Dateline NBC and in the New York Times, the Wall Street Journal, and other media. He is the author of The Paleo Diet and The Paleo Diet Cookbook, among other books, and makes regular media and speaking appearances worldwide.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      John Wiley & Sons
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?afb8df6e